import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, TagList } from '@piplapps/pipl-ui';
import LoadingButton from '../../../../Components/LoadingButton';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import styles from './RemoveUserModal.module.less';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import { ProfileSelectors } from '../../../../Redux/modules/profile/selectors';

const RemoveMultipleUsers = (props) => {
  const usersItems = props.selectedUsers
    .filter((user) => user.original?.email !== props.currentLoggedEmail)
    .map((userRow) => {
      return { label: userRow.original?.email, value: userRow.original?.id };
    });
  const [itemsToShow, setItems] = useState(usersItems);
  const handleRemoveUsers = () => {
    const usersIdsToRemove = itemsToShow.map((item) => item.value);
    props.removeUsers(usersIdsToRemove);
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header} id="modal-title">
        {gettext('Remove users')}
      </div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        {gettext(
          `Are you sure you want to permanently remove ${itemsToShow.length} ${
            itemsToShow.length === 1 ? 'user' : 'users'
          }?`,
        )}
      </div>

      <TagList
        items={itemsToShow}
        icon={<span className={styles.closeTag}>X</span>}
        onClick={(e) => {
          setItems(itemsToShow.filter((item) => item.value !== parseInt(e.currentTarget.id, 10)));
        }}
      />
      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.REMOVE_USERS}
            eventData={{
              manipulatedUsers: itemsToShow.map((item) => item.value).toString(),
              manipulatedUsersEmails: itemsToShow.map((item) => item.label).toString(),
            }}
          >
            <LoadingButton
              buttonClass="primary-red"
              type="submit"
              onClick={() => handleRemoveUsers()}
              text={gettext('Remove users')}
              width="39%"
              loadingText={gettext('Removing')}
              id="submit-button"
              disabled={itemsToShow.length === 0}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            width="39%"
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

RemoveMultipleUsers.propTypes = {
  currentLoggedEmail: PropTypes.string,
  removeUsers: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
  selectedUsers: PropTypes.array,
};

const mapStateToProps = (state) => {
  return { currentLoggedEmail: ProfileSelectors.profileEmailSelector(state) };
};
const mapDispatchToProps = {
  removeUsers: UsersActions.removeUsers,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveMultipleUsers);
